'use client'

import { motion } from 'framer-motion'

interface CarouselMobileProps {
  cards: {
    title: string
  }[]
}

export const CarouselMobile = ({ cards }: CarouselMobileProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-12">
      {cards.map((card, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.1 }} // `once` ensures it only animates once, `amount` controls when it triggers
          transition={{ duration: 0.5, delay: index * 0.1 }}
          // @ts-ignore
          className="heading-s flex-shrink-0 select-none rounded-full bg-gray-50 px-6 py-2 text-center text-base-dark hover:bg-base-dark hover:text-base-light xl:px-8 xl:py-4"
        >
          {card.title}
        </motion.div>
      ))}
    </div>
  )
}
